module.exports = __webpack_public_path__ + "static/media/Kai-Hung Chang.307a97ed.png";